import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
function LegalModal({
  type,
  onClose
}: {
  type: ModalType;
  onClose: () => void;
}) {
  if (!type) return null;
  const content = {
    privacy: {
      title: 'Política de Privacidad',
      body: <div className="space-y-6 text-dark/80 leading-relaxed" data-id="element-33">
          <p data-id="element-34">
            <strong data-id="element-35">Última actualización:</strong> Abril 2026
          </p>

          <section data-id="element-36">
            <h3 className="text-lg font-serif text-dark mb-2" data-id="element-37">
              1. Información que Recopilamos
            </h3>
            <p data-id="element-38">
              Recopilamos información personal que usted nos proporciona
              directamente al realizar una compra, como su nombre, dirección de
              correo electrónico e información de pago. No almacenamos datos de
              tarjetas de crédito; estos son procesados de forma segura por
              nuestro proveedor de pagos.
            </p>
          </section>

          <section data-id="element-39">
            <h3 className="text-lg font-serif text-dark mb-2" data-id="element-40">
              2. Uso de la Información
            </h3>
            <p data-id="element-41">Utilizamos su información personal para:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1" data-id="element-42">
              <li data-id="element-43">Procesar y entregar su compra digital.</li>
              <li data-id="element-44">Enviar comunicaciones relacionadas con su pedido.</li>
              <li data-id="element-45">Mejorar nuestros productos y servicios.</li>
            </ul>
          </section>

          <section data-id="element-46">
            <h3 className="text-lg font-serif text-dark mb-2" data-id="element-47">
              3. Protección de Datos
            </h3>
            <p data-id="element-48">
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger su información personal contra acceso no autorizado,
              pérdida o alteración.
            </p>
          </section>

          <section data-id="element-49">
            <h3 className="text-lg font-serif text-dark mb-2" data-id="element-50">4. Cookies</h3>
            <p data-id="element-51">
              Nuestro sitio web puede utilizar cookies para mejorar su
              experiencia de navegación y analizar el tráfico del sitio. Puede
              configurar su navegador para rechazar cookies.
            </p>
          </section>

          <section data-id="element-52">
            <h3 className="text-lg font-serif text-dark mb-2" data-id="element-53">5. Terceros</h3>
            <p data-id="element-54">
              No vendemos, intercambiamos ni transferimos su información
              personal a terceros, excepto a proveedores de servicios de
              confianza que nos asisten en la operación de nuestro sitio web y
              negocio.
            </p>
          </section>

          <section data-id="element-55">
            <h3 className="text-lg font-serif text-dark mb-2" data-id="element-56">
              6. Sus Derechos
            </h3>
            <p data-id="element-57">
              Usted tiene derecho a acceder, corregir o eliminar su información
              personal en cualquier momento. Para ejercer estos derechos, puede
              contactarnos a través de nuestro sitio web.
            </p>
          </section>
        </div>
    },
    terms: {
      title: 'Términos y Condiciones',
      body: <div className="space-y-6 text-dark/80 leading-relaxed" data-id="element-58">
          <p data-id="element-59">
            <strong data-id="element-60">Última actualización:</strong> Abril 2026
          </p>

          <section data-id="element-61">
            <h3 className="text-lg font-serif text-dark mb-2" data-id="element-62">
              1. Aceptación de los Términos
            </h3>
            <p data-id="element-63">
              Al acceder y utilizar este sitio web y al adquirir nuestros
              productos digitales, usted acepta cumplir con estos Términos y
              Condiciones. Si no está de acuerdo, le pedimos que no utilice
              nuestros servicios.
            </p>
          </section>

          <section data-id="element-64">
            <h3 className="text-lg font-serif text-dark mb-2" data-id="element-65">
              2. Producto Digital
            </h3>
            <p data-id="element-66">
              El eBook "Eco-S.O.S. Detox" es un producto digital de descarga
              inmediata. Al completar la compra, recibirá acceso al archivo
              descargable. El contenido es únicamente para uso personal y no
              puede ser redistribuido, copiado o revendido.
            </p>
          </section>

          <section data-id="element-67">
            <h3 className="text-lg font-serif text-dark mb-2" data-id="element-68">
              3. Política de Reembolso
            </h3>
            <p data-id="element-69">
              Debido a la naturaleza digital del producto, no ofrecemos
              reembolsos una vez que el archivo ha sido descargado. Si
              experimenta problemas técnicos con la descarga, contáctenos y le
              asistiremos.
            </p>
          </section>

          <section data-id="element-70">
            <h3 className="text-lg font-serif text-dark mb-2" data-id="element-71">
              4. Descargo de Responsabilidad
            </h3>
            <p data-id="element-72">
              El contenido de este eBook es únicamente informativo y educativo.
              No constituye consejo médico profesional. Consulte siempre a un
              profesional de la salud antes de realizar cambios en su dieta o
              rutina de bienestar.
            </p>
          </section>

          <section data-id="element-73">
            <h3 className="text-lg font-serif text-dark mb-2" data-id="element-74">
              5. Propiedad Intelectual
            </h3>
            <p data-id="element-75">
              Todo el contenido, diseño, textos e imágenes de este sitio web y
              del eBook son propiedad de Eco-dbooks y están protegidos por las
              leyes de propiedad intelectual.
            </p>
          </section>

          <section data-id="element-76">
            <h3 className="text-lg font-serif text-dark mb-2" data-id="element-77">
              6. Modificaciones
            </h3>
            <p data-id="element-78">
              Nos reservamos el derecho de modificar estos Términos y
              Condiciones en cualquier momento. Las modificaciones entrarán en
              vigor inmediatamente después de su publicación en el sitio web.
            </p>
          </section>
        </div>
    }
  };
  const {
    title,
    body
  } = content[type];
  return <AnimatePresence data-id="element-79">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-80">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="bg-white rounded-3xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-81">
          <div className="flex items-center justify-between p-6 border-b border-sage-light" data-id="element-82">
            <h2 className="text-2xl font-serif text-dark" data-id="element-83">{title}</h2>
            <button onClick={onClose} className="w-10 h-10 rounded-full bg-sage-light flex items-center justify-center text-sage-dark hover:bg-sage hover:text-white transition-colors" data-id="element-84">
              <XIcon className="w-5 h-5" data-id="element-85" />
            </button>
          </div>
          <div className="p-6 overflow-y-auto" data-id="element-86">{body}</div>
        </motion.div>
      </motion.div>
    </AnimatePresence>;
}
export function Footer() {
  const [modal, setModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-dark py-12 text-cream/60 text-center" data-id="element-87">
        <div className="max-w-4xl mx-auto px-6" data-id="element-88">
          <p className="font-serif text-2xl text-cream mb-6" data-id="element-89">
            Eco-S.O.S. Detox
          </p>
          <p className="mb-4" data-id="element-90">
            <a href="https://www.eco-dbooks.com" className="hover:text-white transition-colors" data-id="element-91">
              www.eco-dbooks.com
            </a>
          </p>

          <div className="flex items-center justify-center gap-6 mb-6" data-id="element-92">
            <button onClick={() => setModal('privacy')} className="text-sm hover:text-white transition-colors underline underline-offset-4 decoration-cream/30 hover:decoration-white" data-id="element-93">
              Política de Privacidad
            </button>
            <span className="text-cream/30" data-id="element-94">|</span>
            <button onClick={() => setModal('terms')} className="text-sm hover:text-white transition-colors underline underline-offset-4 decoration-cream/30 hover:decoration-white" data-id="element-95">
              Términos y Condiciones
            </button>
          </div>

          <p className="text-sm" data-id="element-96">
            &copy; {new Date().getFullYear()} Eco-dbooks. Todos los derechos
            reservados.
          </p>
          <p className="text-xs mt-6 max-w-2xl mx-auto opacity-50" data-id="element-97">
            Este producto no sustituye el consejo médico profesional. Consulte a
            su médico antes de comenzar cualquier programa de salud.
          </p>
        </div>
      </footer>

      {modal && <LegalModal type={modal} onClose={() => setModal(null)} data-id="element-98" />}
    </>;
}